import React from 'react';
export function ForWhomSection() {
  return <section className="s-lila fu" data-id="element-207">
      <div className="c" data-id="element-208">
        <span className="slabel" data-id="element-209">¿Es para mí?</span>
        <h2 className="stitle" data-id="element-210">Para quién es este kit.</h2>
        <div className="div-line" data-id="element-211"></div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-[920px] mx-auto mt-8 md:mt-[56px]" data-id="element-212">
          <div className="py-7 md:py-10 px-5 md:px-[34px] rounded-[20px] bg-[var(--bg3)] border border-[rgba(212,184,150,0.2)] shadow-[0_8px_32px_rgba(0,0,0,0.35)] text-center" data-id="element-213">
            <div className="text-[22px] md:text-[26px] mb-3 md:mb-4 text-center text-[var(--gold-l)]" data-id="element-214">
              ✦
            </div>
            <h3 className="font-serif text-[clamp(1.3rem,4vw,1.6rem)] font-700 mb-4 md:mb-6 text-white text-center" data-id="element-215">
              Sí es para vos si…
            </h3>
            <ul className="list-none flex flex-col gap-3 max-w-[380px] mx-auto items-center" data-id="element-216">
              <li className="flex items-start gap-[9px] text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] font-400 text-left w-full" data-id="element-217">
                <span className="text-[var(--gold)] flex-shrink-0 mt-2" data-id="element-218">●</span>
                Pasaste por terapia pero{' '}
                <strong className="text-[#E8C88A] font-700" data-id="element-219">
                  el cuerpo sigue cargando
                </strong>
              </li>
              <li className="flex items-start gap-[9px] text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] font-400 text-left w-full" data-id="element-220">
                <span className="text-[var(--gold)] flex-shrink-0 mt-2" data-id="element-221">●</span>
                Buscás un proceso íntimo, personal y a tu ritmo
              </li>
              <li className="flex items-start gap-[9px] text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] font-400 text-left w-full" data-id="element-222">
                <span className="text-[var(--gold)] flex-shrink-0 mt-2" data-id="element-223">●</span>
                Tenés relaciones, pérdidas o etapas que no cerraron del todo
              </li>
              <li className="flex items-start gap-[9px] text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] font-400 text-left w-full" data-id="element-224">
                <span className="text-[var(--gold)] flex-shrink-0 mt-2" data-id="element-225">●</span>
                Sos terapeuta o coach y buscás recursos simbólicos
                complementarios
              </li>
            </ul>
          </div>

          <div className="py-7 md:py-10 px-5 md:px-[34px] rounded-[20px] bg-[var(--bg3)] border border-[rgba(212,184,150,0.2)] shadow-[0_8px_32px_rgba(0,0,0,0.35)] text-center" data-id="element-226">
            <div className="text-[22px] md:text-[26px] mb-3 md:mb-4 text-center text-[var(--muted)]" data-id="element-227">
              ◈
            </div>
            <h3 className="font-serif text-[clamp(1.3rem,4vw,1.6rem)] font-700 mb-4 md:mb-6 text-white text-center" data-id="element-228">
              No es para vos si…
            </h3>
            <ul className="list-none flex flex-col gap-3 max-w-[380px] mx-auto items-center" data-id="element-229">
              <li className="flex items-start gap-[9px] text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] font-400 text-left w-full" data-id="element-230">
                <span className="text-[var(--muted)] flex-shrink-0 mt-2" data-id="element-231">
                  ●
                </span>
                Esperás resultados sin ningún tipo de acción propia
              </li>
              <li className="flex items-start gap-[9px] text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] font-400 text-left w-full" data-id="element-232">
                <span className="text-[var(--muted)] flex-shrink-0 mt-2" data-id="element-233">
                  ●
                </span>
                Buscás reemplazar atención psicológica urgente
              </li>
              <li className="flex items-start gap-[9px] text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] font-400 text-left w-full" data-id="element-234">
                <span className="text-[var(--muted)] flex-shrink-0 mt-2" data-id="element-235">
                  ●
                </span>
                No estás dispuesto/a a tomarte 20-30 minutos para vos
              </li>
              <li className="flex items-start gap-[9px] text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] font-400 text-left w-full" data-id="element-236">
                <span className="text-[var(--muted)] flex-shrink-0 mt-2" data-id="element-237">
                  ●
                </span>
                Querés una solución mágica sin ningún proceso interno
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}